import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function LoginSuccessPage() {
  const navigate = useNavigate()

  useEffect(() => {
    // Get token from URL params
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')

    if (token) {
      // Store token
      localStorage.setItem('finops_token', token)
      // Clear URL params and redirect to dashboard
      window.history.replaceState({}, document.title, '/login-success')
      navigate('/dashboard', { replace: true })
    } else {
      // No token, redirect to login
      navigate('/login', { replace: true })
    }
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center gradient-hero">
      <div className="card text-center">
        <img src="/hostfully_primary_logo.png" alt="Hostfully" className="h-12 mx-auto mb-4" />
        <div
          className="loading-spinner mx-auto mb-4"
          style={{ width: '3rem', height: '3rem' }}
        ></div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">Authenticating...</h1>
        <p className="text-gray-600">Please wait while we complete your login</p>
      </div>
    </div>
  )
}
